import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MatchingHalvesEmbed from '../components/Exercise/MatchingHalvesEmbed';

export const MatchingHalvesNode = Node.create({
  name: 'matchingHalves',
  
  group: 'block',
  
  atom: true,
  
  draggable: true,
  
  addAttributes() {
    return {
      sentences: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('sentences');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing Matching Halves sentences from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.sentences) {
            return {
              sentences: JSON.stringify(attributes.sentences)
            };
          }
          return {};
        }
      },
      title: {
        default: 'Matching Halves',
        parseHTML: element => element.getAttribute('title') || 'Matching Halves',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="matching-halves"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'matching-halves' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(MatchingHalvesEmbed);
  },
});

// Создаем отдельную команду для вставки Matching Halves exercise
export const insertMatchingHalves = (attributes) => ({ commands }) => {
  return commands.insertContent({
    type: 'matchingHalves',
    attrs: attributes,
  });
}; 